// /**
//  * Clients Grid Marquee Animation
//  * Controls the scroll-based marquee animation for client logos
//  * Optimized for mobile performance and smooth direction changes
//  */

// // Global variable to store the marquee instance
// window.clientsGridMarquee = null;

// class ClientsGridMarquee {
//   constructor(config = {}) {
//     this.currentScroll = 0;
//     this.isScrollingDown = true;
//     this.tweens = [];
//     this.scrollTimeout = null;
//     this.rafId = null;
//     this.isScrolling = false;
//     this.lastScrollTime = 0;
//     this.scrollVelocity = 0;
//     this.scrollHandler = this.handleScroll.bind(this);
//     this.optimizedScrollHandler = this.optimizedScrollHandler.bind(this);

//     // Configuration options
//     this.config = {
//       // Speed multipliers for each marquee row (0 = first row, 1 = second row, etc.)
//       // Values > 1 = faster, < 1 = slower
//       speedMultipliers: [0.6, 0.5, 0.6, 0.5],
//       // Base speed divisor (higher = faster overall)
//       baseSpeedDivisor: 120,
//       // Minimum duration in seconds
//       minDuration: 20,
//       // Scroll direction transition duration
//       directionTransitionDuration: 0.3,
//       // Scroll direction transition ease
//       directionTransitionEase: "power2.out",
//       // Throttle scroll events (ms)
//       scrollThrottle: 16, // ~60fps
//       // Velocity threshold for direction change
//       velocityThreshold: 0.5,
//       // Mobile performance optimizations
//       mobileOptimizations: true,
//       ...config,
//     };

//     this.init();
//   }

//   init() {
//     // Wait for DOM to be ready
//     if (document.readyState === "loading") {
//       document.addEventListener("DOMContentLoaded", () => this.setupMarquee());
//     } else {
//       this.setupMarquee();
//     }
//   }

//   setupMarquee() {
//     const marquees = document.querySelectorAll(".clients-grid__marquee");

//     if (!marquees.length) return;

//     // Check if GSAP is available
//     if (typeof gsap === "undefined") {
//       console.warn("GSAP is required for clients grid marquee animation");
//       return;
//     }

//     // Check for reduced motion preference
//     const prefersReducedMotion = window.matchMedia(
//       "(prefers-reduced-motion: reduce)",
//     ).matches;
//     if (prefersReducedMotion) {
//       console.log(
//         "Reduced motion preference detected - marquee animation disabled",
//       );
//       return;
//     }

//     // Detect mobile device for performance optimizations
//     const isMobile =
//       window.innerWidth <= 768 ||
//       /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//         navigator.userAgent,
//       );

//     if (isMobile && this.config.mobileOptimizations) {
//       // Reduce number of marquees on mobile for better performance
//       const mobileMarquees = Array.from(marquees).slice(0, 2);
//       this.setupMarqueeRow(mobileMarquees, isMobile);
//     } else {
//       this.setupMarqueeRow(marquees, isMobile);
//     }

//     // Add scroll listener
//     this.addScrollListener();
//   }

//   setupMarqueeRow(marquees, isMobile) {
//     marquees.forEach((marquee, index) => {
//       const tracks = marquee.querySelectorAll(".clients-grid__track");

//       if (tracks.length >= 2) {
//         // Calculate duration based on content width for consistent speed
//         const trackWidth = tracks[0].scrollWidth;
//         const baseDuration = Math.max(
//           this.config.minDuration,
//           trackWidth / this.config.baseSpeedDivisor,
//         );

//         // Get speed multiplier for this specific marquee row
//         const speedMultiplier = this.config.speedMultipliers[index] || 1;

//         // Calculate final duration with speed multiplier
//         let finalDuration = baseDuration * speedMultiplier;

//         // Adjust for mobile performance
//         if (isMobile) {
//           finalDuration *= 1.5; // Slower on mobile for better performance
//         }

//         // Create infinite scroll effect with GSAP
//         const tween = gsap
//           .to(tracks, {
//             xPercent: -100,
//             repeat: -1,
//             duration: finalDuration,
//             ease: "linear",
//             // Add mobile-specific optimizations
//             force3D: isMobile, // Force hardware acceleration on mobile
//             transformOrigin: "left center",
//           })
//           .totalProgress(0.5);

//         // Add error handling for tween
//         tween.eventCallback("onComplete", () => {
//           // Ensure continuous animation
//           if (tween.isActive()) {
//             tween.restart();
//           }
//         });

//         this.tweens.push(tween);
//       }
//     });

//     // Set initial position with better mobile handling
//     gsap.set(".clients-grid__track", {
//       xPercent: -50,
//       force3D: isMobile, // Force hardware acceleration
//     });
//   }

//   addScrollListener() {
//     // Use passive scroll listener for better performance
//     window.addEventListener("scroll", this.optimizedScrollHandler, {
//       passive: true,
//     });
//   }

//   optimizedScrollHandler() {
//     // Cancel previous RAF if it exists
//     if (this.rafId) {
//       cancelAnimationFrame(this.rafId);
//     }

//     // Use RAF for smooth 60fps updates
//     this.rafId = requestAnimationFrame(() => {
//       this.handleScroll();
//     });
//   }

//   handleScroll() {
//     const now = performance.now();
//     const newScroll = window.pageYOffset;
//     const deltaTime = now - this.lastScrollTime;

//     // Calculate scroll velocity for smoother direction changes
//     if (deltaTime > 0) {
//       this.scrollVelocity = (newScroll - this.currentScroll) / deltaTime;
//     }

//     // Only update direction if velocity exceeds threshold
//     const shouldChangeDirection =
//       Math.abs(this.scrollVelocity) > this.config.velocityThreshold;
//     const newDirection = newScroll > this.currentScroll;

//     if (shouldChangeDirection && newDirection !== this.isScrollingDown) {
//       this.isScrollingDown = newDirection;
//       this.updateAnimationDirection();
//     }

//     this.currentScroll = newScroll;
//     this.lastScrollTime = now;
//   }

//   updateAnimationDirection() {
//     // Smoothly transition animation direction
//     this.tweens.forEach((tween) => {
//       if (tween && tween.isActive()) {
//         gsap.to(tween, {
//           timeScale: this.isScrollingDown ? 1 : -1,
//           duration: this.config.directionTransitionDuration,
//           ease: this.config.directionTransitionEase,
//           overwrite: true, // Prevent conflicts
//         });
//       }
//     });
//   }

//   // Public method to pause/resume animation
//   setAnimationState(paused) {
//     this.tweens.forEach((tween) => {
//       if (paused) {
//         tween.pause();
//       } else {
//         tween.resume();
//       }
//     });
//   }

//   // Public method to destroy
//   destroy() {
//     // Kill all tweens
//     this.tweens.forEach((tween) => {
//       if (tween && tween.kill) {
//         tween.kill();
//       }
//     });
//     this.tweens = [];

//     // Cancel any pending RAF
//     if (this.rafId) {
//       cancelAnimationFrame(this.rafId);
//       this.rafId = null;
//     }

//     // Clear scroll timeout
//     if (this.scrollTimeout) {
//       clearTimeout(this.scrollTimeout);
//       this.scrollTimeout = null;
//     }

//     // Remove event listeners
//     window.removeEventListener("scroll", this.optimizedScrollHandler);

//     // Reset state
//     this.isScrolling = false;
//     this.scrollVelocity = 0;
//   }
// }

// // Initialize when module is loaded
// // You can customize the speeds by passing a config object:
// // window.clientsGridMarquee = new ClientsGridMarquee({
// //   speedMultipliers: [1.2, 0.7, 1.5, 0.8, 1.3], // Custom speeds for each row
// //   baseSpeedDivisor: 60, // Faster overall speed
// //   minDuration: 15 // Shorter minimum duration
// // });

// // window.clientsGridMarquee = new ClientsGridMarquee({
// //   // Ensure all marquee rows animate on mobile
// //   mobileOptimizations: false,
// // });

let lastScrollTop = window.scrollY;
let direction = -1; // -1 = left, 1 = right
const marqueeSpeedA = 1.5; // pixels per frame for rows 1, 3, 5, ...
const marqueeSpeedB = 0.9; // pixels per frame for rows 2, 4, 6, ...

const marquees = document.querySelectorAll(".clients-grid__marquee");

marquees.forEach((marquee, index) => {
  const inner = marquee;
  const group = marquee.querySelector(".clients-grid__track");
  const speed = index % 2 === 0 ? marqueeSpeedA : marqueeSpeedB;

  // Clone group 2 more times → total 3
  // for (let i = 0; i < 2; i++) {
  //   inner.appendChild(group.cloneNode(true));
  // }

  let offset = 0;
  const groupWidth = group.offsetWidth;

  function animate() {
    offset += speed * direction;

    // wrap offset using modulo
    if (offset <= -groupWidth) offset += groupWidth;
    if (offset >= 0) offset -= groupWidth;

    inner.style.transform = `translateX(${offset}px)`;
    requestAnimationFrame(animate);
  }

  animate();
});

// Scroll listener to flip direction
window.addEventListener("scroll", () => {
  let currentScroll = window.scrollY;
  if (currentScroll > lastScrollTop) {
    direction = -1; // scrolling down → move left
  } else {
    direction = 1; // scrolling up → move right
  }
  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
});
